import * as Type from '../actions/app/types'

import { setInMemory } from '../utils'

const initialState = {
    loader: {
        message: '',
        display: false
    },
    drawer: {
        display: true
    },
    snackbars: [],
    snackbar: {
        message: '',
        autoHideDuration: null,
        mode: 'info',
        position: {vertical: 'top', horizontal: 'right' },
        open: false
    },
    loaders: {},
    hideLeftPanel: false
}

export default function AppReducer(state = initialState, action) {
    if (action.type === Type.SHOW_LOADER || action.type === Type.HIDE_LOADER)
        return setInMemory(state, action, 'loader')
    else if (action.type === Type.SHOW_DRAWER || action.type === Type.HIDE_DRAWER)
        return setInMemory(state, action, 'drawer')
    else if (action.type === Type.SHOW_LEFTPANEL || action.type === Type.HIDE_LEFTPANEL)
        return setInMemory(state, action, 'hideLeftPanel')
    else if (action.type === Type.SHOW_SNACKBAR || action.type === Type.HIDE_SNACKBAR)
        return setInMemory(state, action, 'snackbar')
    else if (action.type === Type.STACK_SNACKBAR)
        return setInMemory(state, action, 'snackbars')
    else if (action.type === Type.SET_LOADER)
        return setInMemory(state, {data: action.data.value}, 'loaders', action.data.section, action.data.loader)
    else if (action.type === Type.SET_LOADERS)
        return setInMemory(state, {data: action.data.value}, 'loaders', action.data.section)

    return state
}
